import styled from "@emotion/styled";
import { formInputTheme } from "../../textinput/styled/formInputTheme";
import { radioLabelTheme } from "./radioTheme";
const getFontWeight = _ref => {
  let {
    isChecked,
    isDisabled,
    themeMode
  } = _ref;
  if (!isDisabled && isChecked) {
    return radioLabelTheme.fontWeight.checked(themeMode);
  } else {
    return radioLabelTheme.fontWeight.unchecked(themeMode);
  }
};
export const RadioLabelText = styled("div")`
    margin-left: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return radioLabelTheme.gap(themeMode);
}};
    margin-top: ${_ref3 => {
  let {
    size,
    themeMode
  } = _ref3;
  return radioLabelTheme.marginTop[size](themeMode);
}};

    color: ${_ref4 => {
  let {
    isDisabled,
    themeMode
  } = _ref4;
  return isDisabled ? radioLabelTheme.color.disabled(themeMode) : radioLabelTheme.color.rest(themeMode);
}};
    font-size: ${_ref5 => {
  let {
    themeMode
  } = _ref5;
  return formInputTheme.fontSize.box(themeMode);
}};
    font-weight: ${getFontWeight};
    user-select: none;
`;
//# sourceMappingURL=RadioLabelText.js.map